export default "__VITE_ASSET__BSb9HbWr__"